import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

const ValuoTable = ({ evaluations, user }) => {
  const intestazioni = [
    { key: "anno", label: "Anno" },
    { key: "status", label: "Stato" },
    { key: "professionista", label: "Professionista" },
    { key: "autovalutazione", label: "Autovalutazione Professionista" },
    { key: "valutazionePartner", label: "Valutazione Partner" },
    { key: "differenza", label: "+ / - Precedente" },
    { key: "dettaglio", label: "Dettaglio" },
  ];

  return (
    <TableContainer
      component={Paper}
      sx={{ overflowX: "auto", borderRadius: 0, boxShadow: "none" }}
    >
      <Table size="medium" sx={{ width: "100%", minWidth: "600px" }}>
        <TableHead>
          <TableRow className="bg-blue-dark">
            {intestazioni.map((col) => (
              <TableCell
                key={col.key}
                sx={{
                  color: "#fff",
                  fontWeight: 600,
                  textAlign: "center",
                  borderRight: "1px solid #fff",
                  fontSize: "15px",
                }}
              >
                <Typography className="color-light">{col.label}</Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {evaluations.map((item) => {
            const phase = Number(item.phase);

            const scoreCollaborator =
              item.data_collaborator?.score_valutation_collaborator ?? "-";

            const scorePartner =
              item.data_partner?.score_valutation_partner ?? "-";

            const showCollaboratorScore = () => {
              if (phase === 0) return user.role === "collaborator";
              if (phase === 1) return user.role === "partner" ? false : true;
              if (phase >= 2) return true;
              return false;
            };

            const showPartnerScore = () => {
              if (phase === 0) return false;
              if (phase === 1) return user.role === "partner";
              if (phase >= 2) return true;
              return false;
            };

            const rowKey = `${item.anno}-${item.mese}-${item.id}`;

            return (
              <TableRow
                key={rowKey}
                sx={{
                  backgroundColor:
                    (user?.role === "collaborator" && phase === 0) ||
                    (user?.role === "partner" && (phase === 1 || phase === 2))
                      ? "#fae63436"
                      : null,
                }}
              >
                <TableCell sx={{ textAlign: "center" }}>
                  <Typography>{item.year}</Typography>
                </TableCell>

                <TableCell sx={{ textAlign: "center" }}>
                  <Typography>
                    {phase === 0
                      ? "Compilazione professionista"
                      : phase === 1
                      ? "Compilazione partner"
                      : phase === 2
                      ? "Revisione congiunta"
                      : "Completata"}
                  </Typography>
                </TableCell>

                <TableCell sx={{ textAlign: "center" }}>
                  <Typography>
                    {user.role === "collaborator"
                      ? user.name
                      : item?.collaborator?.name}
                  </Typography>
                </TableCell>

                {/* COLLABORATOR SCORE */}
                <TableCell sx={{ textAlign: "center" }}>
                  <Typography>
                    {showCollaboratorScore() ? scoreCollaborator : "-"}
                  </Typography>
                </TableCell>

                {/* PARTNER SCORE */}
                <TableCell sx={{ textAlign: "center" }}>
                  <Typography>
                    {showPartnerScore() ? scorePartner : "-"}
                  </Typography>
                </TableCell>

                <TableCell
                  sx={{
                    textAlign: "center",
                    color: item.differenza?.includes("+")
                      ? "green"
                      : item.differenza?.includes("-")
                      ? "red"
                      : "inherit",
                  }}
                >
                  <Typography>{item.differenza ?? "-"}</Typography>
                </TableCell>

                <TableCell sx={{ textAlign: "center" }}>
                  {(user.role === "collaborator" ||
                    user.role === "partner" ||
                    user.role === "superadmin") && (
                    <Link
                      to={`/evaluation/${item.id}`}
                      className="color-purple"
                      style={{
                        fontSize: "16px",
                        textDecoration: "underline",
                        fontWeight: 500,
                      }}
                    >
                      Vedi
                    </Link>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ValuoTable;
